import styled from "styled-components";

import { Trigger } from "../Trigger";

export const StyledStopwatch = styled.div`
  background-color: var(--color-theme-300);
  border-radius: 21px;
  padding: 4px;
  max-width: 320px;
  height: 34px;

  display: flex;
  align-items: center;
`;

export const StyledStopwatchCenterWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledTrigger = styled(Trigger)`
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    fill: var(--color-theme-700);
  }

  &:hover {
    svg {
      fill: var(--color-theme-900);
    }
  }
`;
